import { getFusion } from '../apiHelper/fusionApi'

export function getPCCMedications(patientId) {
  return getFusion('v1/patient/pccmedications/' + patientId)
}

export function getPCCAllergies(patientId) {
  return getFusion('v1/patient/pccallergies/' + patientId)
}

export function getPCCImmunizations(patientId) {
  return getFusion('v1/patient/pccimmunizations/' + patientId)
}

export function getPCCFunctionalStatus(patientId) {
  return getFusion('v1/patient/pccactivitiesofdailyliving/' + patientId)
}

export function getPCCObservations(patientId) {
  return getFusion('v1/patient/pccobservations/' + patientId)
}

export function getPCCConditions(patientId) {
  return getFusion('v1/patient/pccconditions/' + patientId)
}

export function getPCCReport(patient_id, reportType) {
  return getFusion(`/v1/patient/pccdiagnosticreports/${patient_id}/${reportType}`)
}

export function getPCCResultFile(patient_id, reportId) {
  return getFusion(`/v1/patient/pccdiagnosticreportfile/${patient_id}/${reportId}`, {
    responseType: 'blob',
  })
}

export function getPCCData(patient_id) {
  return getFusion(`/v1/patient/pccdata/${patient_id}`)
}

export function getPCCCoverages(patient_id) {
  return getFusion(`/v1/patient/pcccoverages/${patient_id}`)
}

export function getPCCNotes(patient_id) {
  return getFusion(`/v1/patient/pccnotes/${patient_id}`)
}

export function getPCCNoteDetails(patient_id, note_id) {
  return getFusion(`/v1/patient/pccnotedetails/${patient_id}/${note_id}`)
}
